
import { Vue } from "vue-class-component";

export default class Cash extends Vue {}
